import { createApi } from '@reduxjs/toolkit/query/react';
import { coreBaseQuery } from 'services/queries/coreBaseQuery';

export const coreApi = createApi({
  reducerPath: 'coreApi',
  baseQuery: coreBaseQuery,
  endpoints: () => ({}),
});
